import React from "react";

import HeadCell from "./HeadCell";

const HeadBandCell = props => {
  return <HeadCell scope="colgroup" {...props} />;
};

export default HeadBandCell;
